import { createSelector } from '@ngrx/store';

import { ListEntry } from '../list-entry';
import * as dataReducers from './data.reducers';

export const selectDataState = (state) => state.data;
export const selectListEntities = (state) => state.data.lists as dataReducers.ListState;
export const selectCustomerListEntities = (state) => state.data.custLists as dataReducers.CustListState;

export const selectListById = (list: string) =>
  createSelector(selectListEntities, (listState) => (listState.entities ? listState.entities[list] : ({} as ListEntry)));

export const selectCustomerListById = (list: string) =>
  createSelector(selectCustomerListEntities, (listState) => (listState.entities ? listState.entities[list] : ({} as ListEntry)));
